import { useEffect, useState } from "react";
import { Route, Check, ChevronRight } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Loader } from "@/components/common/Loader";
import { cn } from "@/lib/utils";
import { api } from "@/lib/api";

export default function RoadToPro() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/roadmap").then(({ data }) => setData(data)); }, []);
    if (!data) return <Loader label="Loading roadmap" />;

    return (
        <div className="ww-fade-up">
            <PageHeader title="Road To Pro" subtitle="Where you are, where you're heading, and how to get there." />

            <div className="bg-surface border border-border rounded-sm p-6 mb-6">
                <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-muted-foreground font-semibold mb-5">
                    <Route className="w-4 h-4 text-volt" /> Skill Tier Progression
                </div>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                    {data.steps.map((s, i) => (
                        <div key={s.tier} className="flex items-center gap-2 flex-1">
                            <div data-testid={`tier-${s.tier}`} className={cn(
                                "flex-1 rounded-sm border p-3 text-center transition-colors",
                                s.current ? "border-volt bg-volt/10" : s.reached ? "border-success/40 bg-success/5" : "border-border bg-obsidian"
                            )}>
                                <div className="flex items-center justify-center gap-1.5">
                                    {s.reached && !s.current && <Check className="w-3.5 h-3.5 text-success" />}
                                    <span className={cn("font-heading font-semibold text-sm", s.current ? "text-volt" : s.reached ? "text-success" : "text-muted-foreground")}>{s.tier}</span>
                                </div>
                                {s.current && <div className="text-[10px] font-mono text-volt mt-0.5">YOU ARE HERE</div>}
                            </div>
                            {i < data.steps.length - 1 && <ChevronRight className="w-4 h-4 text-muted-foreground hidden sm:block shrink-0" />}
                        </div>
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="bg-surface border border-border rounded-sm p-6 flex flex-col items-center justify-center text-center">
                    <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">Current Tendency</div>
                    <div className="font-heading text-3xl font-black text-volt mt-2">{data.current_tier}</div>
                    <div className="text-sm text-muted-foreground mt-2">Score {data.score} · Next: <span className="text-white">{data.next_tier}</span></div>
                </div>
                <div className="lg:col-span-2 bg-surface border border-border rounded-sm p-6">
                    <h3 className="font-heading font-bold mb-4">Your Roadmap</h3>
                    <div className="space-y-3">
                        {data.roadmap.map((step, i) => (
                            <div key={i} className="flex gap-3" data-testid={`roadmap-step-${i}`}>
                                <span className="grid place-items-center w-7 h-7 rounded-sm bg-volt/10 border border-volt/30 text-volt font-mono text-xs shrink-0">{i + 1}</span>
                                <p className="text-sm text-foreground/90 pt-1">{step}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
